import React, { useState } from 'react';
import makeApi, { URLS } from 'Utils/apiUtil';
import * as CONSTANTS from 'Utils/constants';
import Utils from 'Utils/utils';
import userDetail from 'Stores/userDetail';
import myLeadsState from 'Stores/myLeads';
import { ReactComponent as DirectDialIcon } from 'Assets/svg/contact_detail_icon/direct_dial.svg';
import { ReactComponent as MobileNumberIcon } from 'Assets/svg/contact_detail_icon/mobile_number.svg';
import { ReactComponent as CompanyNumberIcon } from 'Assets/svg/contact_detail_icon/company_number.svg';
import { ReactComponent as OtherNumberIcon } from 'Assets/svg/contact_detail_icon/other_number.svg';
import { ReactComponent as LinkedinIcon } from 'Assets/svg/company-icon/linkedin-logo.svg';
import { ReactComponent as LocationIcon } from 'Assets/svg/location.svg';
import { ContactLocation } from 'Components/common/ContactList/contactLocation';
import { purchaseStatusPopupState } from 'Components/common/purchaseStatusPopup';
import Dropdown from 'Components/common/dropdown';
import { SocialLinks } from './SocialLinks';
import { ContactEmailPhone } from './contactEmailPhone';
import { ContactCompany } from './contactCompany';

const ContactCard = props => {
  const {
    name,
    title,
    owned = false,
    cname,
    contactCity = '',
    contactState = '',
    contactCountry = '',
    companyCountry = '',
    companyState = '',
    companyCity = '',
    contactId,
    currentTab = null,
    email,
    phone = [],
    status = '',
    LOCATION_PREFERENCE = false,
    facebookId = '',
    twitterId = '',
    youtubeId = '',
    linkedInId = '',
    phoneNumberFromVendor,
    score,
  } = props;

  const [
    showMarkAsInactiveConfirmation,
    setShowMarkAsInactiveConfirmation,
  ] = React.useState(false);
  const markAsInactiveClick = (e, masterContactId) => {
    const config = {
      url: URLS.reportMarkAsInactive,
      method: 'POST',
      params: {
        masterContactId,
      },
      data: {},
    };
    makeApi(config)
      .then(response => {
        if (response && response.data !== undefined && response.data === true)
          purchaseStatusPopupState.setToastMsg(
            null,
            null,
            null,
            null,
            null,
            'Contact marked as inactive.',
          );
        else
          purchaseStatusPopupState.setToastMsg(
            null,
            null,
            null,
            null,
            null,
            'Unable to process your request now. Please try later',
          );
        setShowMarkAsInactiveConfirmation(false);
      })
      .catch(error => {
        console.log('reportMarkAsInactive error ', error);
      });
  };
  return (
    <div
      className="contact-card"
      onMouseLeave={e => setShowMarkAsInactiveConfirmation(false)}
    >
      <span className="sharp-point" />
      <div className="contact-card-details">
        <div className="basic-info-wrapper">
          <div className="name-wrapper">
            <div className="contact-name">{name}</div>
            <SocialLinks
              facebookId={facebookId}
              twitterId={twitterId}
              youtubeId={youtubeId}
              linkedInId={linkedInId}
            />
          </div>
          <div className="title">{title}</div>
          <ContactCompany cname={cname} />
        </div>
        <div className="additional-info-wrapper">
          {email !== null && email !== undefined && (
            <ContactEmailPhone
              contactId={contactId}
              email={email}
              score={score}
              status={status}
              phoneNumberFromVendor={phoneNumberFromVendor}
              isDownloaded
            />
          )}
          {(contactCity !== '' ||
            contactState !== '' ||
            contactCountry !== '' ||
            companyCity !== '' ||
            companyState !== '' ||
            companyCountry !== '') && (
            <div className="contact-location-wrapper">
              {!LOCATION_PREFERENCE && (
                <div className="info-icon">
                  <LocationIcon />
                </div>
              )}
              <ContactLocation
                contactCity={contactCity}
                contactState={contactState}
                contactCountry={contactCountry}
                companyCountry={companyCountry}
                companyState={companyState}
                companyCity={companyCity}
                showContactLocation
                showCompanyLocation
                LOCATION_PREFERENCE={LOCATION_PREFERENCE}
              />
            </div>
          )}
          {status !== '' &&
            status !== 'DEAD' &&
            email !== null &&
            email !== undefined && (
              <div className="contact-card-action-wrapper">
                {showMarkAsInactiveConfirmation ? (
                  <>
                    <div
                      className="action-btn"
                      onClick={e => markAsInactiveClick(e, contactId)}
                    >
                      Confirm
                    </div>
                    <div
                      className="action-btn cancel-btn"
                      onClick={e => setShowMarkAsInactiveConfirmation(false)}
                    >
                      Cancel
                    </div>
                  </>
                ) : (
                  <div
                    className="action-btn"
                    onClick={e => setShowMarkAsInactiveConfirmation(true)}
                  >
                    Mark as Inactive
                  </div>
                )}
              </div>
            )}
        </div>
      </div>
    </div>
  );
};

const ContactName = props => {
  const {
    diff,
    name,
    title,
    contactId,
    owned = false,
    purchaseContact,
    contactCity,
    contactState,
    allUpdatedFlag = false,
    contactCountry,
    currentTab = null,
    newTitle = '',
    previousTitle = '',
    newContactState = '',
    newContactCity = '',
    newContactCountry = '',
    updatesCount,
  } = props;

  let contactStr = '';
  if (contactCity) contactStr += contactCity;
  if (contactState)
    if (contactStr !== '') contactStr += `, ${contactState}`;
    else contactStr += contactState;
  if (contactCountry)
    if (contactStr !== '') contactStr += `, ${contactCountry}`;
    else contactStr += contactCountry;

  const [updatedHover, setUpdatesHover] = useState({});

  const updateHoverData = (key, value) => {
    setUpdatesHover({ ...updatedHover, [key]: value });
  };

  const handleNameClick = (e, id) => {
    Utils.mixpanelTrack(CONSTANTS.MX_CONTACT_UPDATE_EVENTS.CONTACT_NAME_CLICK, {
      contactName: name,
      LEAD_BUILDER:
        userDetail.featureFlags &&
        userDetail.featureFlags.LEAD_BUILDER !== undefined
          ? userDetail.featureFlags.LEAD_BUILDER
          : false,
    });
    purchaseContact(e, id);
  };

  return (
    <div className="contact-name">
      {owned ? (
        <div className="name-icon-wrap">
          <Dropdown
            toggleElement={
              <div className="name contact-card-wrapper">
                <div>{name}</div>
              </div>
            }
            showOnHover
          >
            <ContactCard {...props} />
          </Dropdown>
          <SocialLinks {...props} hoverEffect={updatedHover.linkedin} />
        </div>
      ) : (
        <div className="name" onClick={e => handleNameClick(e, contactId)}>
          {name}
        </div>
      )}
      <div
        className={`title ${
          currentTab === 2 || (currentTab === 3 && newTitle)
            ? 'title-for-new-tag'
            : ''
        }`}
      >
        <span className="show-elipsis" title={title}>
          {title}{' '}
        </span>
        {((currentTab === 3 && newTitle) || currentTab === 2) && (
          <span className="updates-container">
            <button type="button" className="btn new-btn" aria-label="NEW" />
          </span>
        )}
      </div>
      {contactStr && (
        <div className="contact-address-info">
          <div className="contact-address-info-wrap">
            <LocationIcon />
            <span className="show-elipsis" title={contactStr}>
              {contactStr}
            </span>
          </div>
          {(newContactCity || newContactCountry || newContactState) &&
            [2, 3].includes(currentTab) &&
            !allUpdatedFlag && (
              <span className="updates-container">
                <button
                  type="button"
                  className="btn new-btn"
                  aria-label="NEW"
                />
              </span>
            )}
          {allUpdatedFlag && updatedHover.location && (
            <div className="ripple-effect" />
          )}
        </div>
      )}
      <div className="updates-contact">
        {(currentTab === 1 || currentTab === 2 || currentTab === 3) &&
          previousTitle && (
            <div className="previous-title">
              <span>Previously</span>
              <span className="span-ml span-mr">:</span>
              <span className="show-elipsis" title={previousTitle}>
                {previousTitle}
              </span>
            </div>
          )}
        {[2, 3].includes(currentTab) && allUpdatedFlag && (
          <div className="other-updated-dropdown-parent">
            <Dropdown
              showOnHover
              toggleElement={
                <div className="other-update-text">
                  <span>
                    {updatesCount > 3 && diff.title !== undefined
                      ? `+${updatesCount - 1} more updates`
                      : `${updatesCount} updates`}
                  </span>
                </div>
              }
            >
              <div>
                <span className="sharp-point" />
                <div className="other-updated-dropdown ">
                  {(diff.city || diff.country || diff.state) && (
                    <span
                      onMouseEnter={() => updateHoverData('location', true)}
                      onMouseLeave={() => updateHoverData('location', false)}
                    >
                      <LocationIcon className="svg-icon-other-updates" />
                      <span>Location</span>
                    </span>
                  )}
                  {diff.phoneMobile && (
                    <span
                      onMouseEnter={() =>
                        myLeadsState.setPhoneNumberFlag('M', contactId)
                      }
                      onMouseLeave={() =>
                        myLeadsState.setPhoneNumberFlag('', '')
                      }
                    >
                      <MobileNumberIcon className="svg-icon-other-updates" />
                      <span>Phone Number</span>
                    </span>
                  )}
                  {diff.phoneDirect && (
                    <span
                      onMouseEnter={() =>
                        myLeadsState.setPhoneNumberFlag('D', contactId)
                      }
                      onMouseLeave={() =>
                        myLeadsState.setPhoneNumberFlag('', '')
                      }
                    >
                      <DirectDialIcon className="svg-icon-other-updates" />
                      <span>Direct dial</span>
                    </span>
                  )}
                  {diff.phoneCompany && (
                    <span
                      onMouseEnter={() =>
                        myLeadsState.setPhoneNumberFlag('C', contactId)
                      }
                      onMouseLeave={() =>
                        myLeadsState.setPhoneNumberFlag('', '')
                      }
                    >
                      <CompanyNumberIcon className="svg-icon-other-updates" />
                      <span>Company HQ number</span>
                    </span>
                  )}
                  {diff.phoneOther && (
                    <span
                      onMouseEnter={() =>
                        myLeadsState.setPhoneNumberFlag('O', contactId)
                      }
                      onMouseLeave={() =>
                        myLeadsState.setPhoneNumberFlag('', '')
                      }
                    >
                      <OtherNumberIcon className="svg-icon-other-updates" />
                      <span>Other Number</span>
                    </span>
                  )}
                  {diff.linkedInURL && (
                    <span
                      onMouseEnter={() => updateHoverData('linkedin', true)}
                      onMouseLeave={() => updateHoverData('linkedin', false)}
                    >
                      <LinkedinIcon className="updated-linkedin" />
                      <span>Linkedin URL</span>
                    </span>
                  )}
                </div>
              </div>
            </Dropdown>
          </div>
        )}
      </div>
    </div>
  );
};

export { ContactName };
export default ContactName;
